import React from 'react';
import { Dialog } from 'primereact/dialog';
import { InputSwitch } from 'primereact/inputswitch';
import { useTranslation } from 'react-i18next';

/* Izbor alarma koji kruže po mapi.

   Alarmi se NE prikazuju istovremeno — smenjuju se, svaki po minut, pa pauza.
   Zato je ovo spisak prekidača, a ne skup nezavisnih dugmadi: uključiš šta te
   zanima, a mapa ih redom pokazuje. Ako je uključena samo jedna vrsta, ona se
   vrti sama; ako su uključene sve tri, dolaze na red jedna za drugom.

   Vrste koje još nisu napravljene stoje u spisku ugašene i onemogućene, da se
   vidi šta dolazi — ne skrivaju se, jer korisnik traži gde su. */

const DialogAlarmi = ({ vidljiv, vrste, izbor, onIzbor, onZatvori }) => {
    const { t } = useTranslation();

    const ukljucenih = vrste.filter(v => v.dostupno && izbor[v.kljuc]).length;

    return (
        <Dialog
            header={t('gps.izborAlarma')}
            visible={vidljiv}
            onHide={onZatvori}
            className="gps-dijalog-alarmi"
            style={{ width: '30rem', maxWidth: '95vw' }}
            draggable={false}
            dismissableMask
        >
            <div className="gps-dijalog-vrste">
                {vrste.map(v => (
                    /* htmlFor je izricit, ne oslanja se na to sto je input unutar
                       labele — tako i klik na naziv ili opis pali prekidac. */
                    <label
                        key={v.kljuc}
                        htmlFor={`alarm-${v.kljuc}`}
                        className={`gps-dijalog-vrsta${v.dostupno ? '' : ' gps-dijalog-vrsta-uskoro'}`}
                    >
                        <span className="gps-dijalog-ikona">
                            <i className={v.ikona} />
                        </span>

                        <span className="gps-dijalog-tekst">
                            <span className="gps-dijalog-naziv">{t(v.naziv)}</span>
                            <span className="gps-dijalog-opis">
                                {v.dostupno ? t(v.opis) : t('gps.uPripremi')}
                            </span>
                        </span>

                        <InputSwitch
                            inputId={`alarm-${v.kljuc}`}
                            className="gps-prekidac"
                            checked={!!izbor[v.kljuc]}
                            disabled={!v.dostupno}
                            onChange={(e) => onIzbor(v.kljuc, e.value)}
                        />
                    </label>
                ))}
            </div>

            {/* Objašnjenje stoji na dnu, kao fusnota — pravilo smenjivanja se
                pročita jednom, a spisak se gleda svaki put. */}
            <p className="gps-dijalog-fusnota">
                {ukljucenih > 1 ? t('gps.izborAlarmaVise') : t('gps.izborAlarmaOpis')}
            </p>
        </Dialog>
    );
};

export default DialogAlarmi;
